/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import { useLayout, ILayout } from '../../core'
import { Navbar } from './Navbar'
import { PageTitle } from '../toolbar/page-title/PageTitle'
import { HeaderGeneralSearch } from './HeaderGeneralSearch'
import { useAuth } from '../../../../app/modules/auth'
import { getDefaultLandingRoute } from '../../../../app/routing/routeHelper'

const updateDOM = (config: ILayout) => {
  if (config.app?.header?.default?.fixed?.desktop) {
    document.body.setAttribute('data-kt-app-header-fixed', 'true')
    document.body.setAttribute('data-kt-app-header-minimize', 'on')
  }

  if (config.app?.header?.default?.fixed?.mobile) {
    document.body.setAttribute('data-kt-app-header-fixed-mobile', 'true')
  }

  if (config.app?.header?.default?.stacked) {
    document.body.setAttribute('data-kt-app-header-stacked', 'true')
  }
}

export function HeaderWrapper() {
  const { config, classes } = useLayout()
  const { currentUser } = useAuth()
  const landingRoute = getDefaultLandingRoute(currentUser)

  useEffect(() => {
    updateDOM(config)
  }, [config])
  
  if (!config.app?.header?.display) {
    return null
  }

  return (
    <div
      id='sc_app_header'
      className='app-header sc-app-header-main'
    >
      <div
        id='sc_app_header_container'
        className={clsx(
          'app-container d-flex align-items-center justify-content-between w-100 flex-grow-1 position-relative ps-8 ps-lg-9 pe-4 pe-lg-6',
          classes.headerContainer.join(' '),
          config.app?.header?.default?.containerClass
        )}

      >
        {/* Mobile sidebar toggle */}
        {config.app.sidebar?.display && (
          <div className='d-flex align-items-center d-lg-none ms-n2 me-2' title='Show sidebar menu'>
            <div className='btn btn-icon btn-active-color-primary w-35px h-35px' id='sc_app_sidebar_mobile_toggle'>
              <KTIcon iconName='abstract-14' className='fs-1' />
            </div>
          </div>
        )}

        {/* Mobile Logo */}
        <div className='position-absolute top-50 start-50 translate-middle d-lg-none'>
          <Link to={landingRoute} title='Home'>
            <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo.png')} className='h-35px h-sm-40px' />
          </Link>
        </div>

        {/* Desktop logo (if not using sidebar) */}
        {!(config.layoutType === 'dark-sidebar' || config.layoutType === 'light-sidebar') && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15'>
            <Link to={landingRoute} title='Home'>
              <img
                alt='Logo'
                src={toAbsoluteUrl('/media/logos/logo.png')}
                className='h-25px h-lg-30px app-sidebar-logo-default theme-light-show'
              />
              <img
                alt='Logo'
                src={toAbsoluteUrl('/media/logos/logo_dark.png')}
                className='h-25px h-lg-30px app-sidebar-logo-default theme-dark-show'
              />
            </Link>
          </div>
        )}

        {/* Header Left: Breadcrumbs / PageTitle firmly pinned on the far left with comfortable margin */}
        <div className='d-flex align-items-center me-auto my-auto min-w-0 ms-5 ms-lg-7'>
          <PageTitle />
        </div>

        {/* Header Right: Search + Activity Log Bell + Avatar pinned on the far right */}
        <div className='d-flex align-items-center gap-2 gap-sm-3 ms-auto flex-shrink-0'>
          {/* General Global Search */}
          <HeaderGeneralSearch />

          {/* Navbar (Bell + Avatar) */}
          <Navbar />
        </div>
      </div>
    </div>
  )
}